// Keep the original nodes/anchors, including editions whose chapter headings
// and verses are siblings. Chapter containers are also the search index.
export default function prepareReadingChapters(html, { gold = false, hebrew = false } = {}) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const chapters = Array.from(doc.querySelectorAll('div[id]')).filter((node) =>
    /^\d+$/.test(node.id) && node.querySelector('h3'));
  if (hebrew) chapters.forEach((chapter, index) => {
    const nextChapter = chapters[index + 1];
    while (chapter.nextSibling && chapter.nextSibling !== nextChapter) {
      chapter.appendChild(chapter.nextSibling);
    }
  });
  // English books already have one table container per chapter.
  if (!chapters.length) chapters.push(...Array.from(doc.querySelectorAll('div[id="contenten"]'))
    .filter((node) => node.querySelector('td.vn')));
  chapters.forEach((chapter) => {
    chapter.classList.add('bible-reading-chapter');
    if (gold) chapter.classList.add('gold-reading-surface');
  });
  if (gold) Array.from(doc.body.children).forEach((node) => {
    if (node.matches('h1, h2')) node.classList.add('gold-reading-surface', 'bible-reading-title');
  });
  return doc.body.innerHTML;
}
